import React from 'react';
import { Button, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnalytics } from '@fortawesome/pro-solid-svg-icons';

export class NavigationButtons extends React.Component<{}, {}> {
  render() {
    return (     
      <Container className="nav-button-container">
          <LinkContainer exact to="/client/add">
            <Button
              type="button"
            ><FontAwesomeIcon icon="user-plus"/>&nbsp;&nbsp;Add Client
            </Button>
          </LinkContainer>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <LinkContainer exact to="/bloodwork/add">
            <Button
              type="button"
            ><FontAwesomeIcon icon="tint"/>&nbsp;&nbsp;Add Test Results
            </Button>
          </LinkContainer>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <LinkContainer exact to="/bloodwork/analyze">
            <Button
              type="button"
            ><FontAwesomeIcon icon={faAnalytics} />&nbsp;&nbsp;Manage Test Results
            </Button>
          </LinkContainer>
          &nbsp;&nbsp;&nbsp;
          <LinkContainer exact to="/client/edit/manage">
            <Button
              type="button"
            ><FontAwesomeIcon icon="user-friends"/>&nbsp;&nbsp;Manage Clients
            </Button>
          </LinkContainer>
      </Container>
    );
  }
}
